import {
  ROUTE,
  ROUTE_PATH
} from 'modules/routes/constants/index.cjs'
import { matchPath } from 'react-router-dom'
import getRouteAndMatchDataRouteUtil from 'modules/routes/utils/get-route-and-match-data'

/**
 * Gets the route matching the given pathname.
 * @param  {string} pathname
 * @returns {Object}
 */
export default function getRouteAndMatchRouteUtil (pathname) {
  let match
  let route = Object.values(ROUTE)
    .find(route => {
      if (!route.path) {
        return false
      }
      match = matchPath(route, pathname)
      return !!match
    })

  if (!route) {
    route = ROUTE[ROUTE_PATH.NOT_FOUND]
  }

  return getRouteAndMatchDataRouteUtil({
    route,
    match
  })
}
